import { render, staticRenderFns } from "./theoryLibaray.vue?vue&type=template&id=add13ccc&scoped=true"
import script from "./theoryLibaray.vue?vue&type=script&lang=js"
export * from "./theoryLibaray.vue?vue&type=script&lang=js"
import style0 from "./theoryLibaray.vue?vue&type=style&index=0&id=add13ccc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add13ccc",
  null
  
)

export default component.exports